import { useAuth0 } from '@auth0/auth0-react';

let authContext: ReturnType<typeof useAuth0> | undefined = undefined;

export class AdminBackendAuthHandler {
  constructor() {
    if (!authContext) {
      throw new Error(
        'Must call setAuthContextOnBackendService first before trying to use BackendService',
      );
    }
  }

  withAuthToken(): Promise<string | null> {
    const { isAuthenticated, user, getAccessTokenSilently } = authContext!;

    if (!isAuthenticated || !user) {
      return Promise.resolve(null);
    }

    return getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_BACKEND_AUDIENCE, // 👈 must match your Auth0 API identifier
        scope: 'openid profile email',
      },
    });
  }

  async logout() {
    const { logout, getIdTokenClaims } = authContext!;

    const claims = await getIdTokenClaims();
    const idToken = claims?.__raw;

    logout({
      logoutParams: {
        id_token_hint: idToken,
        returnTo: `${window.location.origin}`,
        client_id: process.env.REACT_APP_AUTH0_CLIENT_ID!,
      },
    });
  }
}

export default class BackendAuthHandler extends AdminBackendAuthHandler {}

const setAuthContextOnBackendService = (context: ReturnType<typeof useAuth0>) => {
  authContext = context;
};

export { setAuthContextOnBackendService };
